import SockJS from 'sockjs-client'
import webstomp from 'webstomp-client'
import { auth } from './auth'

const WEBSTOMP_URL = (() => {
    const hostname = window && window.location && window.location.hostname
    const match = /\w+\.(\w+\.)?budbee\.com/.exec(hostname)
    if (match == null) {
        return process.env.VUE_APP_WEBSTOMP_URL
    }

    return `https://webstomp.${match[1] || ''}budbee.com/stomp`
})()

const token = auth.getToken()
let connection

function connect(authHeaders) {
    return new Promise((resolve, reject) => {
        const stomp = webstomp.over(new SockJS(WEBSTOMP_URL), {
            debug: false,
        })

        stomp.connect(
            authHeaders,
            () => {
                resolve({ stomp, authHeaders })
            },
            () => {
                reject(new Error('cant connect to STOMP'))
            },
        )
    })
}

if (token) {
    const { id_token: idToken } = auth.getToken()
    const authHeaders = {
        Authorization: idToken,
    }

    connection = connect(authHeaders)
}

function subscribeToDriverPosition(driverId, callback) {
    if (!connection) {
        return Promise.reject(new Error('No connection'))
    }

    return connection.then(({ stomp, authHeaders }) => {
        const { id: subscriptionId } = stomp.subscribe(
            `/events/topic/position_updated/${driverId}`,
            (message) => {
                const data = JSON.parse(message.body)

                if (callback) {
                    callback(data.position)
                }
            },
            authHeaders,
        )

        return subscriptionId
    })
}

function subscribeToParcelLifecycleUpdates(routeId, callback) {
    if (!connection) {
        return Promise.reject(new Error('No connection'))
    }

    return connection.then(({ stomp, authHeaders }) => {
        const { id: subscriptionId } = stomp.subscribe(
            `/events/topic/parcel_lifecycle_updated/${routeId}`,
            () => {
                if (callback) {
                    callback()
                }
            },
            authHeaders,
        )

        return subscriptionId
    })
}

function unsubscribe(subscriptionId) {
    connection.then(({ stomp }) => {
        stomp.unsubscribe(subscriptionId)
    })
}

export { subscribeToDriverPosition, unsubscribe, subscribeToParcelLifecycleUpdates }
